"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DropdownContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Dropdown = require("./Dropdown.styled");
var _Icon = require("../Icon");
var _styles = require("../../shared/styles");
var _OutsideAlerter = _interopRequireDefault(require("../../molecules/OutsideAlerter"));
var _jsxRuntime = require("react/jsx-runtime");
var DropdownContext = exports.DropdownContext = /*#__PURE__*/(0, _react.createContext)(null);

/**
 * The dropdown which should be wrapped around a dropdown menu
 * @param children The dropdown menu
 * @param size The size of the dropdown, default is 'm'
 * @param error The error state of the dropdown, default is false
 * @param disabled Disabled? True/False
 * @param onSelect The function to be called on selection, takes the value of the selected item
 * @param initialValue The initial value, default is a placeholder
 * @param fit Fit the width of the content or a fixed 200 px width
 * @param cy Cypress data tag
 * @returns {JSX.Element} The dropdown component
 * @constructor
 */
var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
    size = _ref.size,
    error = _ref.error,
    disabled = _ref.disabled,
    onSelect = _ref.onSelect,
    initialValue = _ref.initialValue,
    fit = _ref.fit,
    dataCy = _ref['data-cy'];
  var _ref2 = (0, _react.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    expanded = _ref3[0],
    setExpanded = _ref3[1];
  var _ref4 = (0, _react.useState)(),
    _ref5 = _slicedToArray(_ref4, 2),
    selectedItem = _ref5[0],
    setSelectedItem = _ref5[1];
  var toggleDropdown = function toggleDropdown(e) {
    e.stopPropagation();
    setExpanded(!expanded);
  };
  var closeDropdown = function closeDropdown() {
    return setExpanded(false);
  };
  var selectItem = function selectItem(e, item) {
    e.stopPropagation();
    onSelect(item.props.data);
    setSelectedItem(item);
    toggleDropdown(e);
  };
  var select = function select(e, value, item) {
    e.stopPropagation();
    onSelect(value);
    setSelectedItem( /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.CurrentSelection, {
      size: size,
      data: value,
      children: item
    }));
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutsideAlerter.default, {
    callback: closeDropdown,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Dropdown.Position, {
      size: size,
      fit: fit,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Dropdown.DropdownWrapper, {
        size: size,
        error: error,
        expanded: expanded,
        disabled: disabled,
        onClick: function onClick(e) {
          return toggleDropdown(e);
        },
        fit: fit,
        "data-cy": dataCy,
        children: [selectedItem, expanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          size: _styles.iconSizes.atom[size],
          icon: 'chevronUp'
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          size: _styles.iconSizes.atom[size],
          icon: 'chevronDown'
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DropdownContext.Provider, {
        value: {
          size: size,
          selectItem: selectItem,
          setSelectedItem: setSelectedItem,
          initialValue: initialValue,
          expanded: expanded,
          select: select
        },
        children: children
      })]
    })
  });
};
Dropdown.defaultProps = {
  size: 'm',
  error: false,
  onSelect: function onSelect(value) {
    return value;
  }
};
var _default = exports.default = Dropdown;